// extracted by mini-css-extract-plugin
export default {"header":"Menu_header__BkjSa","header__logo":"Menu_header__logo__-qrCS","header__itensMenu":"Menu_header__itensMenu__GmycK"};